function Header() {
    return (
        <header>
            <div className="py-6 px-4 sm:px-6 lg:px-60" >
                <h1 className="text-2xl md:text-4xl md:leading-relaxed font-bold text-center text-gray-800 leading-loose" data-aos="fade-up" data-aos-duration="1000" data-aos-delay="50">
                    Hi, I'am
                    <br />
                    <span className="text-transparent text-2xl md:text-5xl bg-clip-text bg-gradient-to-r from-blue-400 to-blue-600">Adam Ray</span>
                    <br />
                    I'am Web Developer
                </h1>
                <p className="text-gray-600 text-center mt-4 text-sm md:text-sm tracking-wide" data-aos="fade-up" data-aos-duration="1500" data-aos-delay="500">
                    I'm from South Jakarta and currently a student at Budi Luhur University. I am very interested in programming, especially software development. If you want to see all of my projects, you can visit my
                    <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-blue-600 underline">
                        <a href="https://github.com/adamrayw" className="ml-1 ">
                            github.
                        </a>
                    </span>
                </p>
            </div>
        </header>
    )
}

export default Header